import React, { Component } from 'react';
import { deepOrange500 } from 'material-ui/styles/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import AppBar from 'material-ui/AppBar';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import MenuItem from 'material-ui/MenuItem';
import Livro from 'material-ui/svg-icons/av/library-books';
import Fechar from 'material-ui/svg-icons/content/clear';
import { Card, CardTitle, CardText } from 'material-ui/Card';
import Drawer from 'material-ui/Drawer';
import { Link } from 'react-router';
import AppStore from './stores/app-store.js'
import { mudaPortuguesActions } from './actions/app-actions.js'
import { mudaInglesActions } from './actions/app-actions.js'
import './App.css';

const muiTheme = getMuiTheme({
  palette: {
    accent1Color: deepOrange500,
  },
});


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      historiaAberta: false,
      legendas: AppStore.legendas,
    }
    this.onChangeLingua = this.onChangeLingua.bind(this);
  }

  componentWillMount() {
    AppStore.addChangeLinguaListener(this.onChangeLingua);
  }

  componentWillUnmount() {
    AppStore.removeChangeLinguaListener(this.onChangeLingua);
  }


  onChangeLingua() {
    this.setState({
      legendas: AppStore.legendas,
    })

  }

  handleToggle = () => this.setState({ historiaAberta: !this.state.historiaAberta });

  handleIngles = () => mudaInglesActions.ingles();
  handlePortugues = () => mudaPortuguesActions.portugues();

  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className="App">
          <AppBar
            title="Eu Conto!"
            onTitleTouchTap={this.handleToggle}
            style={{ fontFamily: 'OpenSans', fontSize: '36px', padding: '10px', color: 'white' }}
            iconElementLeft={
              <IconMenu
                iconButtonElement={
                  <IconButton ><MoreVertIcon /></IconButton>
                }
                iconStyle={{ color: 'white' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                targetOrigin={{ horizontal: 'left', vertical: 'top' }}
              >
                <MenuItem onTouchTap={this.handleIngles}>
                  English
              </MenuItem>
                <MenuItem onTouchTap={this.handlePortugues}>
                  Português
              </MenuItem>
                <MenuItem>
                  <Link to="/capa" style={{ fontFamily: 'OpenSans', color: 'gray' }}>{this.state.legendas.inicio}</Link>
                </MenuItem>
                <MenuItem>
                  <Link to="/minhashistorias" style={{ fontFamily: 'OpenSans', color: 'gray' }}>{this.state.legendas.minhasHistorias}</Link>
                </MenuItem>
                <MenuItem>
                  <Link to="/mostrahistoria" style={{ fontFamily: 'OpenSans', color: 'gray' }}>{this.state.legendas.sair}</Link>
                </MenuItem>
              </IconMenu>
            }
            iconElementRight={
              <IconButton onTouchTap={this.handleToggle}>
                <Livro />
              </IconButton>
            }
          />
          <Drawer width={200} openSecondary={true} open={this.state.historiaAberta} >
              <IconButton onTouchTap={this.handleToggle}>
                <Fechar />
              </IconButton>            
            <Card>
              <CardTitle title={this.state.legendas.historia} />
              <CardText>
                {AppStore.getSequenciaHistorias().map(function (paragrafo) {
                  return <p>{paragrafo + '.'}</p>
                })}
              </CardText>
            </Card>
          </Drawer>
          <img src={'./imagens/united_states_of_america_64.png'} alt="English" onClick={this.handleIngles} />
          <img src={'./imagens/brazil_64.png'} alt="Português" onClick={this.handlePortugues} />
          {this.props.children}
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js